import React, { useEffect, useState } from 'react';

import { Link, useHistory, useLocation } from 'react-router-dom';

import Dashboard from '~/layouts/Dashboard';
import SettingsPersonal from './SettingsPersonal';
import SettingsCompany from './SettingsCompany';
import SettingsImport from './SettingsImport';
import SettingsApp from './SettingsApp';
import SettingsPayment from './SettingsPayment';
import SettingsMonthlyPayment from './SettingsMonthlyPayment';
import SettingsFidelit from './SettingsFidelit';

import { useAuth } from '~/hooks/auth';
import getInitialLettersOfName from '~/utils/getInitialLettersOfName';
import SettingsPrinters from './SettingsPrinters';

interface HistoryData {
  tab: string;
}

const Profile: React.FC = () => {
  const history = useHistory();
  const { user } = useAuth();
  const [tab, setTab] = useState('company');
  const [showMenu, setShowMenu] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (history.location.state) {
      const { tab: tabName } = history.location.state as HistoryData;
      setTab(tabName);
    } else if (location.state) {
      const item = location.state as any;
      setTab(item.tab);
    }
  }, [history, location]);

  return (
    <Dashboard>
      <div>
        <div className="nk-block">
          <div className="card card-bordered">
            <div className="card-aside-wrap">
              <div className="card-inner card-inner-lg">
                {tab === 'personal' && (
                  <SettingsPersonal openMenu={() => setShowMenu(true)} />
                )}
                {tab === 'company' && (
                  <SettingsCompany openMenu={() => setShowMenu(true)} />
                )}
                {tab === 'app' && (
                  <SettingsApp openMenu={() => setShowMenu(true)} />
                )}
                {tab === 'printers' && (
                  <SettingsPrinters openMenu={() => setShowMenu(true)} />
                )}
                {tab === 'import' && (
                  <SettingsImport openMenu={() => setShowMenu(true)} />
                )}
                {tab === 'payment' && (
                  <SettingsPayment openMenu={() => setShowMenu(true)} />
                )}
                {tab === 'monthlyPayment' && (
                  <SettingsMonthlyPayment openMenu={() => setShowMenu(true)} />
                )}
                {tab === 'fidelit' && (
                  <SettingsFidelit openMenu={() => setShowMenu(true)} />
                )}
              </div>
              <div
                className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${
                  showMenu && 'content-active'
                }`}
                data-content="userAside"
                data-toggle-screen="lg"
                data-toggle-overlay="true"
              >
                <div className="card-inner-group">
                  <div className="card-inner">
                    <div className="user-card">
                      <div className="user-avatar bg-primary">
                        <span>{getInitialLettersOfName(user.name)}</span>
                      </div>
                      <div className="user-info">
                        <span className="lead-text">{user.name}</span>
                        <span className="sub-text">{user.email}</span>
                      </div>
                    </div>
                  </div>

                  <div className="card-inner p-0">
                    <ul className="link-list-menu">
                      <li>
                        <Link
                          to="#personal"
                          className={tab === 'personal' ? 'active' : ''}
                          onClick={() => {
                            setShowMenu(false);
                            setTab('personal');
                          }}
                        >
                          <em className="icon ni ni-user-fill-c" />
                          <span>Informações Pessoais</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#company"
                          className={tab === 'company' ? 'active' : ''}
                          onClick={() => {
                            setShowMenu(false);
                            setTab('company');
                          }}
                        >
                          <em className="icon ni ni-building-fill" />
                          <span>Empresa</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#app"
                          className={tab === 'app' ? 'active' : ''}
                          onClick={() => {
                            setShowMenu(false);
                            setTab('app');
                          }}
                        >
                          <em className="icon ni ni-browser" />
                          <span>Aplicativo</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#printers"
                          className={tab === 'printers' ? 'active' : ''}
                          onClick={() => {
                            setShowMenu(false);
                            setTab('printers');
                          }}
                        >
                          <em className="icon ni ni-printer" />
                          <span>Impressoras</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#import"
                          className={tab === 'import' ? 'active' : ''}
                          onClick={() => {
                            setShowMenu(false);
                            setTab('import');
                          }}
                        >
                          <em className="icon ni ni-upload" />
                          <span>Importações</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#fidelit"
                          className={tab === 'fidelit' ? 'active' : ''}
                          onClick={() => {
                            setShowMenu(false);
                            setTab('fidelit');
                          }}
                        >
                          <em className="icon ni ni-star" />
                          <span>Fidelidade</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#payment"
                          className={tab === 'payment' ? 'active' : ''}
                          onClick={() => {
                            setShowMenu(false);
                            setTab('payment');
                          }}
                        >
                          <em className="icon ni ni-wallet-out" />
                          <span>Pagamentos</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#monthly-payment"
                          className={tab === 'monthlyPayment' ? 'active' : ''}
                          onClick={() => {
                            setShowMenu(false);
                            setTab('monthlyPayment');
                          }}
                        >
                          <em className="icon ni ni-money" />
                          <span>Mensalidades</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {showMenu && (
                <div
                  className="toggle-overlay"
                  data-target="userAside"
                  onClick={() => setShowMenu(current => !current)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </Dashboard>
  );
};

export default Profile;
